<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    href: {
        type: [String, Object],
        required: true,
    },
    icon: {
        /** @type import('vue').PropType<IconName> */
        type: String,
        required: true,
    },
    /**
     * Whether to use exact matching for the active state.
     * @default false
     */
    exact: {
        type: Boolean,
        default: false,
    },
});

const getVariant = (isActive, isExactActive) => {
    const shouldBeBold = props.exact ? isExactActive : isActive;
    return shouldBeBold ? 'bold' : 'light';
};
</script>

<template>
    <RouterLink
        v-slot="{ isActive, isExactActive }"
        :to="href"
        :exact-active-class="exact ? 'font-bold' : undefined"
        :active-class="!exact ? 'font-bold' : undefined"
        class="flex items-center gap-3"
    >
        <CFIcon
            :name="icon"
            :variant="getVariant(isActive, isExactActive)"
            class="size-4"
        />

        {{ title }}
    </RouterLink>
</template>
